export enum FavoriteTypeEnum {
   COURSE = 0,
   CHAPTER = 1
};
